/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";
import { Link } from "react-router-dom";

/**
 * Component props
 */
export interface IButtonGroupComponentProps {
	flow: "row"|"column";
	align?: "start"|"center"|"end";
	children?: any;
}

/**
 * Button Group
 *
 * @param props Component props
 */
export function ButtonGroup(props: IButtonGroupComponentProps) {

	const mods = [
		"flow-" + props.flow,
		"align-" + (props.align || "start")
	];

	const stl = bem("button-group", null, mods);

	return <div className={stl.str}>
		{props.children}
	</div>;

}
